<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import Vue from 'vue';

import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import NextWorkflowStepButton from './components/workflow/NextWorkflowStepButton.vue';

Vue.component('v-icon', Icon);
Vue.component('next-workflow-step-button', NextWorkflowStepButton);

export default {};
</script>

<style lang="scss">
</style>
